import axios from "axios";

export const getForgetPassApi = (payload) => {
  // console.log(payload,"top payload")
  const prodUrl = process.env.REACT_APP_BASE_URL;
  return axios
    .post(
      prodUrl + "user-service/api/v1/users/settings/request-password-reset/",
      {
        email_or_phone: payload.phone,
      }
    )
    .then(function (response) {
      // console.log(response, "otp api response")
      return response;
    })
    .catch((error) => {
      return error;
    });
};
